import { put } from './requests'

export function updateAccountRole ({ id, ...accountRole }) {
  return put(`account_roles/${id}`, { accountRole })
}

export function updateAccountRoleTeams (id, teamsIds) {
  return put(`account_roles/${id}/team_memberships`, { account_role: { team_ids: teamsIds } })
}
